import React from "react";
import IndiaTrackerCards from "./IndiaTrackerCards/IndiaTrackerCards";

const IndiaTracker = (props) => {
  return (
    <div>
      <h1>India Covid-19 Tracker</h1>
      <IndiaTrackerCards />
    </div>
  );
};

export default IndiaTracker;
